import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import  ParticipantForm  from './pages/ParticipantForm'
import { LoginPage } from './pages/LoginPage'
import { AdminPage } from './pages/AdminPage'
import { useAuth } from './hooks/useAuth'
import {JSX} from "react";
import {MantineProvider} from "@mantine/core";
import '@mantine/core/styles.css';
import {ToastContainer} from "react-toastify";
import '@mantine/dates/styles.css';
// import FindCampaignPage from "./pages/public/FindCampaignPage";

function ProtectedRoute({ children }: { children: JSX.Element }) {
    const { isAuthenticated } = useAuth()

    if (!isAuthenticated) {
        return <Navigate to="/login" />
    }

    return children
}

function App() {
    return (

        <MantineProvider>
            <div className='w-screen  overflow-hidded bg-white'>
                <ToastContainer />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={
                            <>
                                {/*<FindCampaignPage />*/}
                                <ParticipantForm />
                            </>
                        } />
                        <Route path="/login" element={<LoginPage />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <>
                                        <AdminPage />
                                        <ToastContainer />
                                    </>
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/campaign/:code" element={<ParticipantForm />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </MantineProvider>
    )
}

export default App
